import { render, staticRenderFns } from "./accountManagement.vue?vue&type=template&id=fff99124&scoped=true&"
import script from "./accountManagement.vue?vue&type=script&lang=js&"
export * from "./accountManagement.vue?vue&type=script&lang=js&"
import style0 from "./accountManagement.vue?vue&type=style&index=0&id=fff99124&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff99124",
  null
  
)

export default component.exports